import CabinCrewImg from "../../assets/images/jobs/cabin crew.png";
import TicketAgentImg from "../../assets/images/jobs/airline ticket agent.png";
import AirHostessImg from "../../assets/images/jobs/Air Hostess.png";
import RampAgentImg from "../../assets/images/jobs/Ground Staff (Ramp Agent).png";
import GroundStaffSupervisorImg from "../../assets/images/jobs/Ground Staff Supervisor.png";
import CustomerServiceAgentImg from "../../assets/images/jobs/Customer Service Agent.png";
import AirTrafficImg from "../../assets/images/jobs/Air Traffic Controller (Assistant Level).png";
import PassengerServiceImg from "../../assets/images/jobs/Passenger Service Agent.png";
import LoungeHostImg from "../../assets/images/jobs/Lounge Host  VIP Service Lead.png";
import CleaningStaffImg from "../../assets/images/jobs/Cleaning Staff  Housekeeping.png";

export const jobsData = [
  {
    id: 1,
    title: "Cabin Crew",
    image: CabinCrewImg,
    description:
      "Cabin crew members are a vital part of the aviation industry, representing the airline and shaping the overall passenger experience. At Bright Airways, we select well-trained, confident, and customer-focused individuals who can ensure a safe, comfortable, and memorable journey for every traveler.",
    responsibilities: [
      "Warmly welcoming passengers and assisting them with seating",
      "Monitoring passenger safety and ensuring all guidelines are followed",
      "Acting as an Air Host/Hostess throughout the flight",
      "Delivering clear and accurate in-flight instructions",
      "Serving meals, beverages, and providing exceptional onboard hospitality",
    ],
    salary: "₹33,000 – ₹50,000",
    qualification: "Intermediate or Equivalent",
    totalVacancies: 947,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 2,
    title: "Airline Ticket Agent",
    image: TicketAgentImg,
    description:
      "As the title suggests, an airline ticket agent plays an essential role in assisting passengers throughout their travel process. At Bright Airways, our ticketing staff ensures smooth, efficient, and friendly service from the moment travelers arrive at the airport.",
    responsibilities: [
      "Handling airline ticket sales",
      "Assisting passengers with seat upgrades when available",
      "Guiding travelers through check-in and boarding procedures",
      "Making and managing reservations",
      "Offering accurate and timely flight-related information",
    ],
    salary: "₹31,500 – ₹33,500",
    qualification: "Intermediate or Equivalent",
    totalVacancies: 250,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 3,
    title: "Air Hostess",
    image: AirHostessImg,
    description:
      "Air hostesses play an essential role in delivering outstanding hospitality and safety onboard. At Bright Airways, we hire individuals who are confident, well-spoken, and passionate about customer service.",
    responsibilities: [
      "Greeting passengers with professionalism and warmth",
      "Conducting safety demonstrations and instructions",
      "Handling passenger concerns with care and patience",
      "Serving meals, snacks, and beverages",
      "Maintaining cabin cleanliness and comfort",
    ],
    salary: "₹32,000 – ₹43,000",
    qualification: "Intermediate or Equivalent",
    totalVacancies: 812,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 4,
    title: "Ground Staff (Ramp Agent)",
    image: RampAgentImg,
    description:
      "Ramp Agents ensure smooth ground operations and timely aircraft handling. At Bright Airways, we hire hardworking, disciplined individuals for this crucial position.",
    responsibilities: [
      "Loading and unloading baggage securely",
      "Guiding aircraft during arrival and departure",
      "Helping with cargo and equipment handling",
      "Ensuring safety protocols on the ramp",
      "Coordinating with flight crew and ground controllers",
    ],
    salary: "₹25,000 – ₹38,000",
    qualification: "10th / Intermediate",
    totalVacancies: 540,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 5,
    title: "Ground Staff Supervisor",
    image: GroundStaffSupervisorImg,
    description:
      "Ground Staff Supervisors oversee the smooth functioning of airport operations. At Bright Airways, we choose responsible, leadership-oriented candidates for this role.",
    responsibilities: [
      "Supervising ground staff teams on daily tasks",
      "Monitoring ramp, baggage, and check-in operations",
      "Reporting and resolving irregularities",
      "Ensuring safety and service standards",
      "Coordinating with airline management",
    ],
    salary: "₹39,000 – ₹56,000",
    qualification: "Intermediate / Graduate",
    totalVacancies: 421,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 6,
    title: "Customer Service Agent",
    image: CustomerServiceAgentImg,
    description:
      "Customer Service Agents (CSA) ensure a smooth experience for passengers from entry to boarding. Bright Airways seeks friendly, confident, and helpful individuals for this position.",
    responsibilities: [
      "Assisting passengers at check-in counters",
      "Guiding travelers with boarding and gates",
      "Handling customer issues and queries",
      "Managing baggage tags and verification",
      "Ensuring professional customer interaction",
    ],
    salary: "₹22,000 – ₹30,000",
    qualification: "Intermediate or Equivalent",
    totalVacancies: 880,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 7,
    title: "Air Traffic Controller (Assistant Level)",
    image: AirTrafficImg,
    description:
      "Air Traffic Controllers assist in managing safe aircraft movement. We hire individuals who are disciplined, alert, and have strong focus.",
    responsibilities: [
      "Monitoring aircraft movement on ground and air",
      "Coordinating communication with pilots",
      "Helping maintain safe distances between flights",
      "Supporting smooth runway operations",
      "Reporting unusual activity",
    ],
    salary: "₹19,000 – ₹28,000",
    qualification: "Intermediate (Science) / Graduate",
    totalVacancies: 398,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 8,
    title: "Passenger Service Agent",
    image: PassengerServiceImg,
    description:
      "PSAs assist passengers with documentation, boarding, and airport processes. We hire confident and polite individuals for this role.",
    responsibilities: [
      "Helping passengers with boarding formalities",
      "Checking travel documents",
      "Guiding travelers through airport counters",
      "Managing queues and customer support",
      "Assisting passengers with inquiries",
    ],
    salary: "₹23,000 – ₹30,000",
    qualification: "Intermediate or Equivalent",
    totalVacancies: 765,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 9,
    title: "Lounge Host / VIP Service Lead",
    image: LoungeHostImg,
    description:
      "Lounge Hosts ensure exceptional experience for premium passengers. We look for candidates with excellent communication and hospitality skills.",
    responsibilities: [
      "Greeting VIP guests and offering premium services",
      "Serving food and beverages",
      "Maintaining lounge cleanliness and comfort",
      "Assisting passengers with flight information",
      "Ensuring smooth VIP movement",
    ],
    salary: "₹18,000 – ₹30,000",
    qualification: "10th / 12th / Graduate",
    totalVacancies: 320,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
  {
    id: 10,
    title: "Cleaning Staff / Housekeeping",
    image: CleaningStaffImg,
    description:
      "Housekeeping staff ensure cleanliness across airport and aircraft areas. Bright Airways hires dedicated and responsible individuals for this essential role.",
    responsibilities: [
      "Cleaning aircraft cabins and terminals",
      "Maintaining washrooms and seating areas",
      "Handling waste disposal",
      "Ensuring hygiene standards",
      "Supporting airport maintenance staff",
    ],
    salary: "₹17,000 – ₹24,000",
    qualification: "8th / 10th Pass",
    totalVacancies: 500,
    showApplyButton: true,
    applyButtonText: "Apply Now",
    applyButtonDisabled: false,
  },
];
